export const REPORT_REASONS = [
  'Spam', 'Nudity or pornography', 'Sexual exploitation or solicitation', 'Sharing private images',
  'Involves a child', 'Hate speech or symbols', 'Bullying or harassment', 'False information — health',
  'False information — politics', 'False information — social issue', 'Digitally created or altered',
  'Something else', 'Violent threat', 'Animal abuse', 'Death or severe injury',
  'Dangerous organizations or individuals', 'Scam or fraud', 'Intellectual property violation',
  'Sharing personal information', 'Other privacy violation', 'Impersonation', 'Suicide or self-harm',
  'Eating disorder', 'Something else', 'Repeated unwanted contact', 'Stalking-like behavior',
];
